/* src/app/system-view/main-dashboard/table-card/table-card.component.scss */
:host {
  display: block;
  height: 100%;
}
.tc-shell {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-height: 0;
  border-radius: var(--tem-radius);
  border: 1px solid var(--tem-border);
  box-shadow: var(--tem-shadow);
  background: var(--tem-surface);
  overflow: hidden;
  transition: border-color 0.2s ease;
}
.tc-shell:hover {
  border-color: var(--tem-deep);
}
.tc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--tem-space-1) var(--tem-space-1) var(--tem-space-1) var(--tem-space-3);
  border-bottom: 1px solid var(--tem-border);
  flex-shrink: 0;
  background: var(--tem-surface-2);
  max-height: 40px;
}
.tc-title {
  display: flex;
  align-items: center;
  gap: var(--tem-space-2);
  min-width: 0;
}
.tc-title-icon {
  font-size: var(--tem-fs-lg);
  color: var(--tem-deep);
  flex-shrink: 0;
}
.tc-title-text {
  font-size: var(--tem-fs-md);
  font-weight: 600;
  color: var(--tem-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tc-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.tc-menu-icon {
  margin-right: var(--tem-space-2);
}
.tc-grid-wrapper {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
}
.tc-spin {
  height: 100%;
}
.tc-spin ::ng-deep .ant-spin-container {
  height: 100%;
}
.tc-footer {
  display: flex;
  align-items: center;
  padding: var(--tem-space-1) var(--tem-space-3);
  border-top: 1px solid var(--tem-border);
  flex-shrink: 0;
}
.tc-last-update {
  display: inline-flex;
  align-items: center;
  gap: var(--tem-space-1);
  font-size: var(--tem-fs-sm);
  font-weight: 500;
  color: var(--tem-warn);
  background: color-mix(in srgb, var(--tem-warn) 10%, transparent);
  border-radius: 20px;
  padding: 2px var(--tem-space-2);
}
.tc-last-update-icon {
  font-size: var(--tem-fs-sm);
}
.tc-refresh-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 100;
}
/*# sourceMappingURL=table-card.component.css.map */
